import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./ApprovalsTab.module.css";

export default function ApprovalsTab() {
  const [users, setUsers] = useState<any[]>([]);

  const load = () => {
    const token = localStorage.getItem("bni_token");
    axios
      .get(
        (process.env.REACT_APP_API_URL || "http://localhost:8080") +
          "/api/admin/users",
        { headers: { Authorization: "Bearer " + token } }
      )
      .then((r) => {
        const pending = r.data.data.filter((u: any) => u.role === "USER");
        setUsers(pending);
      })
      .catch((error) => {
        console.log("error  while loading user details", error);
      });
  };

  useEffect(() => load(), []);

  const approve = async (id: string) => {
    const token = localStorage.getItem("bni_token");
    try {
      await axios.post(
        (process.env.REACT_APP_API_URL || "http://localhost:8080") +
          "/api/auth/approve/" +
          id,
        {},
        { headers: { Authorization: "Bearer " + token } }
      );
      load();
    } catch (error) {
      console.log("error  while approving memebrs details", error);
    }
  };

  return (
    <div>
      <h2 className={styles.heading}>Pending Approvals</h2>

      {users.length === 0 && (
        <p className={styles.empty}>No pending users ✅</p>
      )}

      {users.map((u) => (
        <div key={u._id} className={styles.card}>
          <div>
            <h3>{u.name}</h3>
            <p>{u.email}</p>
          </div>
          <button className={styles.approveBtn} onClick={() => approve(u._id)}>
            Approve → Member
          </button>
        </div>
      ))}
    </div>
  );
}
